import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useLocation, Link as RouterLink } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

/**
 * Shown when ProtectedFeatureRoute blocks access to a module the current
 * plan doesn't include. Kept intentionally simple — no invented payment
 * flow, per requirement #16. If/when a real subscription/upgrade page
 * exists, point the button below at it.
 */
const SubscriptionRequiredPage: React.FC = () => {
  const location = useLocation();
  const blockedFeature = (location.state as any)?.blockedFeature as string | undefined;

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh" px={2}>
      <Paper variant="outlined" sx={{ p: 4, maxWidth: 420, textAlign: "center", borderRadius: 2 }}>
        <LockOutlinedIcon sx={{ fontSize: 40, color: "text.secondary", mb: 1 }} />
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Upgrade Required
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          {blockedFeature
            ? `The "${blockedFeature}" module is not included in your current plan.`
            : "This module is not included in your current plan."}{" "}
          Please upgrade to get access.
        </Typography>
        <Button variant="contained" component={RouterLink} to="/dashboard">
          Back to Dashboard
        </Button>
      </Paper>
    </Box>
  );
};

export default SubscriptionRequiredPage;